import { render, staticRenderFns } from "./LoginWidget.vue?vue&type=template&id=1bb364c6&"
import script from "./LoginWidget.vue?vue&type=script&lang=ts&"
export * from "./LoginWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports